import { render } from "./printLabel.vue?vue&type=template&id=dd25c2d2"
import script from "./printLabel.vue?vue&type=script&lang=js"
export * from "./printLabel.vue?vue&type=script&lang=js"

import "./printLabel.vue?vue&type=style&index=0&id=dd25c2d2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__